// extracted by mini-css-extract-plugin
export default {"messagesContainer":"messagesContainer__RX_UX","message":"message__Kd0VH","selected":"selected__WCVny","selectedText":"selectedText__lnfKG"};